<template>
<footer>
    <div class="footer-wrapper">
        <div class="footer-top">
            <div class="footer-img-wrapper">
                <div class="footer-img" data-aos="fade-up">
                    <img src="../assets/cleandata_logo_white.svg" />
                </div>
                <p data-aos="fade-up" data-aos-delay="100">
                    Mit CleanData findest Du heraus, welche Unternehmen Deine Daten<br> gespeichert haben, und kannst sie automatisiert löschen lassen. Deine<br> Privatsphäre, Deine Entscheidung.
                </p>
            </div>

            <div class="footer-links footer-menu">
                <p class="title" data-aos="fade-up">MENU</p>

                <a href="#services" data-aos="fade-up" data-aos-delay="100">Lösungen</a>
                <a href="#resume" data-aos="fade-up" data-aos-delay="150">Mein Bereich</a>
                <a href="#pricing" data-aos="fade-up" data-aos-delay="200">Preise</a>
                <a href="#contact" data-aos="fade-up" data-aos-delay="250">Kontakt</a>
            </div>

            <div class="footer-socials" data-aos="fade-up">
                <div class="social instagram">
                    <img src="../assets/home-imgs/social/instagram.png" />
                </div>
                <div class="social youtube">
                    <img src="../assets/home-imgs/social/youtube.png" />
                </div>
                <div class="social facebook">
                    <img src="../assets/home-imgs/social/facebook.png" />
                </div>
                <div class="social linkedin">
                    <img src="../assets/home-imgs/social/linkedin.png" />
                </div>
            </div>
        </div>

        <div class="footer-bottom">
            <p class="copyright">
                Copyright © 2025 CleanData. Alle Rechte vorbehalten.
            </p>
            <div class="terms">
                <router-link to="/terms" target="_blank">AGB & Nutzungsbedingungen</router-link>
                <span>
                    <router-link to="/impressum" target="_blank">Impressum  </router-link> 
                    /
                    <router-link to="/datenschutz" target="_blank">Datenschutzrichtlinie</router-link>
                </span> 
            </div>
        </div>
    </div>
</footer>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
 footer {
     background-color: #3C3C3C;
     padding: 22px 0;

     .footer-wrapper {
         width: 78%;
         margin: 0 auto;

         .footer-top {
             width: 100%;
             justify-content: space-between;
             display: flex;
             margin-bottom: 100px;

             .footer-img-wrapper {
                 .footer-img {
                     width: 140px;

                     img {
                         width: 100%;
                     }
                 }

                 p {
                     font-size: 16px;
                     color: white;
                     margin-top: 42px;
                 }
             }

             .footer-links {
                 color: white;
                 margin-top: 84px;

                 .title {
                     font-size: 24px;
                     margin-bottom: 35px;
                 }

                 a {
                     color: white;
                     display: block;
                     margin-bottom: 15px;
                     font-size: 18px;
                 }
             }

             .footer-socials {
                 display: flex;
                 align-items: center;
                 gap: 35px;

                 .social {
                     img {
                         width: 100%
                     }

                     width: 20px;
                     height: 20px;
                 }

                 .youtube {
                     width: 28px;
                     height: 20px;
                 }

                 .facebook {
                     width: 10px;
                     height: 20px;
                 }
             }
         }

         .footer-bottom {
             justify-content: space-between;
             display: flex;
             align-items: center;
             border: 2px solid transparent;
             border-top-color: #464646;
             padding: 40px 0;
             padding-bottom: 18px;
             color: white;

             p {
                 font-size: 20px;
             }

             .terms {
                 justify-content: space-between;
                 display: flex;
                 align-items: center;
                 gap: 96px;

                 a {
                     color: white;
                     font-size: 20px;
                 }
             }
         }
     }
 }

 /* imac 24" */
 /* 2048 x 1152 */
 @media (min-width: 2048px) {}

 /* 2304-1440 */
 @media (min-width: 2304px) {
     footer {
         .footer-wrapper {
             .footer-top {
                 .footer-img-wrapper {
                     .footer-img {
                         width: 160px;
                     }

                     p {
                         font-size: 18px;
                     }
                 }

                 .footer-links {
                     .title {
                         font-size: 26px;
                     }

                     a {
                         font-size: 20px;
                     }
                 }

                 .footer-socials {
                     .social {
                         width: 30px;
                         height: 30px;
                     }

                     .youtube {
                         width: 38px;
                         height: 30px;
                     }

                     .facebook {
                         width: 14px;
                         height: 24px;
                     }
                 }
             }

             .footer-bottom {
                 p {
                     font-size: 20px;
                 }

                 .terms a {
                     font-size: 20px;
                 }
             }
         }
     }
 }

 /* 2470 - 1328 */
 @media (min-width: 2470px) {}

 /*2560-1440*/
 @media (min-width: 2560px) {
     footer {
         .footer-wrapper {
             .footer-top {
                 .footer-img-wrapper {
                     .footer-img {
                         width: 180px;
                     }

                     p {
                         font-size: 20px;
                     }
                 }

                 .footer-links {
                     .title {
                         font-size: 28px;
                     }

                     a {
                         font-size: 22px;
                     }
                 }

                 .footer-socials {
                     .social {
                         width: 35px;
                         height: 35px;
                     }

                     .youtube {
                         width: 43px;
                         height: 35px;
                     }

                     .facebook {
                         width: 19px;
                         height: 29px;
                     }
                 }
             }

             .footer-bottom {
                 p {
                     font-size: 22px;
                 }

                 .terms a {
                     font-size: 22px;
                 }
             }
         }
     }
 }

 /* 2880-1670 */
 @media(min-width: 2880px) {}

 /* 3000-1870 */
 @media(min-width: 3000px) {
     footer {
         .footer-wrapper {
             .footer-top {
                 .footer-img-wrapper {
                     .footer-img {
                         width: 200px;
                     }

                     p {
                         font-size: 22px;
                     }
                 }

                 .footer-links {
                     .title {
                         font-size: 30px;
                     }

                     a {
                         font-size: 24px;
                     }
                 }

                 .footer-socials {
                     .social {
                         width: 40px;
                         height: 40px;
                     }

                     .youtube {
                         width: 48px;
                         height: 40px;
                     }

                     .facebook {
                         width: 24px;
                         height: 39px;
                     }
                 }
             }

             .footer-bottom {
                 p {
                     font-size: 24px;
                 }

                 .terms a {
                     font-size: 24px;
                 }
             }
         }
     }

 }

 /*3200-1800*/
 @media(min-width: 3200px) {}

 /*3360-1890 1695*/
 @media(min-width:3360px) {}

 @media(max-width: 1800px) {}

 /* macbook pro 16 2021 */
 /*1728x1085*/
 @media(max-width: 1728px) {}

 /*1680-1080*/
 @media(max-width: 1680px) {}

 /*1640-1080*/
 @media(max-width: 1640px) {}

 /*my big monitor 1600 - 757 */
 @media (max-width: 1600px) {
     footer {
         .footer-wrapper {
             .footer-top {
                 .footer-img-wrapper {
                     .footer-img {
                         width: 120px;
                     }

                     p {
                         font-size: 14px;
                     }
                 }

                 .footer-links {
                     .title {
                         font-size: 20px;
                     }

                     a {
                         font-size: 16px;
                     }
                 }
             }

             .footer-bottom {
                 p {
                     font-size: 18px;
                 }

                 .terms a {
                     font-size: 18px;
                 }
             }
         }
     }

 }

 /*my small monitor 1536-864*/
 @media(max-width:1536px) {}

 /* 1440-990 */
 @media(max-width:1440px) {
     footer .footer-wrapper {
         width: 80%;
     }
 }

 /*1366-768*/
 @media (max-width:1366px) {
     footer {
         .footer-wrapper {
             width: 85%;

             .footer-bottom {
                 p {
                     font-size: 16px;
                 }

                 .terms {
                     gap: 80px;

                     a {
                         font-size: 16px;
                     }
                 }
             }
         }
     }
 }

 /* 1280-800 */
 @media (max-width:1280px) {}

 @media (max-width:1200px) {
     footer {
         .footer-wrapper {
             .footer-top {
                 margin-bottom: 50px;

                 .footer-img-wrapper {
                     .footer-img {
                         width: 90px;
                     }

                     p {
                         font-size: 12px;
                     }
                 }

                 .footer-links {
                     .title {
                         font-size: 18px;
                     }

                     a {
                         font-size: 14px;
                     }
                 }

                 .footer-socials .youtube {
                     width: 24px;
                     height: 16px;
                 }
             }

             .footer-bottom {
                 p {
                     font-size: 14px;
                 }

                 .terms a {
                     font-size: 14px;
                 }
             }
         }
     }

 }

 /*1134x712*/
 @media(max-width:1134px) {}

 /*1114x705*/
 @media(max-width:1114px) {}

 /*1024-768*/
 @media (max-width:1024px) {}

 /* ipad pro 2/3 */
 /* 981x1024 */
 @media (max-width:981px) {
     footer {
         .footer-wrapper {
             width: 95%;

             .footer-top {
                 .footer-socials .youtube {
                     width: 24px;
                     height: 16px;
                 }
             }
         }
     }
 }

 /* 962x601 */
 @media(max-width: 962px) {}

 /* 900x1600 */
 @media(max-width: 900px) {}

 /* 884 x 1104 */
 @media(max-width: 884px) {}

 /*834-1112*/
 @media(max-width: 834px) {}

 /* 820x1080 */
 @media(max-width: 820px) {}

 /* 800x1280 */
 @media(max-width: 800px) {}

 /*778-304*/
 @media(max-width: 778px) {}

 /* 768x1024 */
 @media(max-width: 768px) {
     footer {
         .footer-wrapper {
             .footer-top {
                 .footer-links .title {
                     font-size: 16px;
                 }

                 .footer-socials {
                     gap: 25px;
                 }
             }

             .footer-bottom {
                 p {
                     font-size: 12px;
                 }

                 .terms {
                     gap: 40px;

                     a {
                         font-size: 12px;
                     }
                 }
             }
         }
     }
 }

 /*712-1138*/
 @media(max-width:712px) {}

 /* 694-768 */
 @media(max-width:694px) {}

 /* 678-1024 */
 @media(max-width:678px) {
     footer {
         padding: 25px 0;

         .footer-wrapper {
             .footer-top {
                 flex-direction: column;
                 margin-bottom: 50px;

                 .footer-img-wrapper {
                     .footer-img {
                         margin: 0 auto;
                     }

                     p {
                         font-size: 16px;
                         text-align: center;
                         margin-top: 20px;
                     }
                 }

                 .footer-links {
                     text-align: center;
                     margin-top: 46px;

                     .title {
                         font-size: 19px;
                         margin-bottom: 30px;
                     }

                     a {
                         font-size: 17px;
                     }
                 }

                 .footer-socials {
                     margin-top: 40px;
                     justify-content: center;
                     gap: 35px;

                     .youtube {
                         width: 28px;
                         height: 20px;
                     }
                 }
             }

             .footer-bottom {
                 flex-direction: column;

                 p {
                     font-size: 16px;
                 }

                 .terms a {
                     font-size: 14px;
                 }

                 .copyright {
                     margin-bottom: 30px;
                     width: 190px;
                     text-align: center;
                 }
             }
         }
     }
 }

 /* 600x962 */
 @media(max-width:600px) {
     footer {
         .footer-wrapper {
             .footer-bottom {
                 .copyright {
                     width: 60%;
                 }
             }
         }
     }
 }

 /* 577-951 */
 @media(max-width:577px) {}

 /* 540-960 */
 @media(max-width:540px) {}

 /*480-800*/
 @media (max-width:480px) {
     footer .footer-wrapper {
         width: 95%;
     }
 }

 /*438-1024*/
 @media(max-width:438px) {}

 /* ip14 pro max */
 /* 430x932 */
 @media(max-width:430px) {}

 /* ip13 pro max */
 /* 428-926 */
 @media (max-width:428px) {}

 /*414-736 617   */
 @media (max-width:414px) {
     footer {
         .footer-wrapper {
             .footer-bottom {
                 .terms {
                     gap: 30px;
                 }

                 .copyright {
                     width: 65%;
                 }
             }
         }
     }

 }

 /*390 x 844*/
 @media(max-width:393px) {}

 /*384-640*/
 @media(max-width:384px) {}

 /*375*/
 @media(max-width:375px) {
     footer {
         .footer-wrapper {
             .footer-bottom {
                 .copyright {
                     width: 70%;
                 }
             }
         }
     }
 }

 /*360x640*/
 @media(max-width:360px) {}

 /*320x568*/
 @media(max-width:320px) {}
</style>
